import BusRoutes from "../components/pages/BusRoutes";

export default BusRoutes;
